import { generateAiDraft, analyzeBusinessMatch, refreshBusinessMatches } from './backend';

const draft = (purpose, { companyId, targetUserId, targetCompanyId, context = {}, tone = 'professional' }) =>
  generateAiDraft(companyId, { purpose, targetUserId, targetCompanyId, context, tone });

export const generateIntroduction = (args) => draft('introduction', args);
export const generateMessage = (args) => draft('message', args);
export const generateMeetingRequest = (args) => draft('meeting_request', args);
export const generateCalendarRequest = (args) => draft('calendar_request', args);
export const generateConnectionRequest = (args) => draft('connection_request', args);
export const generateFollowUp = (args) => draft('follow_up', args);
export const generatePostMeetingFollowUp = (args) => draft('post_meeting_follow_up', args);
export const generateReply = (args) => draft('reply', args);
export const rewriteMessage = (args) => draft('rewrite', args);
export const analyzeMatch = ({ companyId, targetUserId, targetCompanyId, context = {} }) => analyzeBusinessMatch(companyId, { targetUserId, targetCompanyId, context });

export async function regenerateMyMatches(companyId) {
  return refreshBusinessMatches(companyId);
}

export default {
  generateIntroduction,
  generateMessage,
  generateMeetingRequest,
  generateCalendarRequest,
  generateConnectionRequest,
  generateFollowUp,
  generatePostMeetingFollowUp,
  generateReply,
  rewriteMessage,
  analyzeMatch,
  regenerateMyMatches,
};
